import {
  Component,
  ChangeDetectionStrategy,
  Input,
  OnChanges
} from '@angular/core';

import dayjs from 'dayjs';

@Component({
  selector: 'date-utc',
  template: '<time [attr.datetime]="timestamp">{{ localizedFormat }}</time>',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DateUtcComponent implements OnChanges {
  @Input()
  public timestamp!: string | null;

  @Input()
  public format = 'LL';

  public localizedFormat!: string;

  ngOnChanges(): void {
    this.localizedFormat = dayjs.utc(this.timestamp)
      .local()
      .format(this.format);
  }
}